module.exports = __webpack_public_path__ + "static/media/events.d7c0f1af.jpg";